import '../styles/parking.css';
import imgretour from '../assets/images/back-512x512.png';
import img from '../assets/images/Logo_main_CNAM.png';
import { Link } from 'react-router-dom';

function Parking() {
    const codeParking = sessionStorage.getItem("codeParking:");
    const getVersionning = sessionStorage.getItem("versionning:");

    return (
        <div className="body_profil">
            <div className="div_entete">
                <Link to="/Accueil">
                    <img className="small_profil" src={imgretour} alt="retour" />
                </Link>
            </div>
            <div className="div_formation">
                <label className="label_Formation">Code du Parking</label>
                <textarea
                    className="texte_area_formation"
                    readOnly
                    rows="5"
                    defaultValue={codeParking}
                />

            </div>
            <img className="img_CNAM" src={img} alt="logo cnam" />
            <footer>
                <span>{getVersionning}</span>
            </footer>
        </div>
    )
}
export default Parking;
